import AGREGAR_PROGRAMA_INVERSION from '@/graphql/mutations/administracion/catalogos/programasinversion/agregarProgramaInversion.gql';
import PROGRAMAS_INVERSIONES from '@/graphql/querys/administracion/catalogos/programasinversiones/programasInversiones.gql';
import ACTUALIZAR_PROGRAMA_INVERSION from '@/graphql/mutations/administracion/catalogos/programasinversion/actualizarProgramaInversion.gql';
import REMOVER_PROGRAMA_INVERSION from '@/graphql/mutations/administracion/catalogos/programasinversion/removerProgramaInversion.gql';

export default {
  methods: {
    async mixAgregarProgramaInversion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_PROGRAMA_INVERSION,
        variables: {
          programaInversion: this.programaInversion,
        },
        update: (store, { data: { agregarProgramaInversion } }) => {
          const data = store.readQuery({ query: PROGRAMAS_INVERSIONES });
          data.programasInversiones.push(agregarProgramaInversion);
          store.writeQuery({ query: PROGRAMAS_INVERSIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarProgramaInversion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_PROGRAMA_INVERSION,
        variables: {
          id: this.programaInversionEditar.id,
          programaInversion: this.programaInversion,
        },
        update: (store, { data: { actualizarProgramaInversion } }) => {
          const data = store.readQuery({ query: PROGRAMAS_INVERSIONES });
          const { programasInversiones } = data;
          const index = programasInversiones
            .findIndex((programaInversion) => programaInversion.id
            === actualizarProgramaInversion.id);
          if (index !== -1) {
            programasInversiones.splice(index, 1, actualizarProgramaInversion);
          }
          store.writeQuery({ query: PROGRAMAS_INVERSIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarProgramaInversion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PROGRAMA_INVERSION,
        variables: {
          id: this.programaInversionEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: PROGRAMAS_INVERSIONES });
          const { programasInversiones } = data;
          const index = programasInversiones
            .findIndex((programaInversion) => programaInversion.id
            === this.programaInversionEliminar.id);
          if (index !== -1) {
            programasInversiones.splice(index, 1);
          }
          store.writeQuery({ query: PROGRAMAS_INVERSIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
